import {
  Box,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
  useMediaQuery
} from '@mui/material'
import moment from 'moment'
import { useLayoutEffect, useState } from 'react'
import { flexItemCenter, flexItemLeft, flexrow } from '../../global'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import { makeStyles } from '@mui/styles'
import { appTheme } from '../../theme'

var isMobView = false
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 3.5 + ITEM_PADDING_TOP,
      width: 92
    }
  }
}

const addStyle = makeStyles({
  monthWidth: {
    minWidth: '16.5rem',
    [appTheme.breakpoints.down('md')]: {
      minWidth: '10rem'
    }
  },
  headerStyle: {
    [appTheme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }
})

export const ToolbarComponent = (props: {
  onView(arg0: string): unknown
  date: any
  onNavigate: any
  view: string
}) => {
  isMobView = useMediaQuery(appTheme.breakpoints.down('md'))
  const className = addStyle()
  const [viewState, setViewState] = useState(props.view)
  useLayoutEffect(() => {
    setViewState(props.view)
  }, [props.view])

  const goToBack = () => {
    let view = viewState
    let mDate = props.date
    let newDate
    if (view === 'month' || view === 'agenda') {
      newDate = new Date(mDate.getFullYear(), mDate.getMonth() - 1, 1)
    } else if (view === 'week') {
      newDate = new Date(
        mDate.getFullYear(),
        mDate.getMonth(),
        mDate.getDate() - 7,
        1
      )
    } else {
      newDate = new Date(
        mDate.getFullYear(),
        mDate.getMonth(),
        mDate.getDate() - 1,
        1
      )
    }
    props.onNavigate('prev', newDate)
  }
  const goToNext = () => {
    let view = viewState
    let mDate = props.date
    let newDate
    if (view === 'month' || view === 'agenda') {
      newDate = new Date(mDate.getFullYear(), mDate.getMonth() + 1, 1)
    } else if (view === 'week') {
      newDate = new Date(
        mDate.getFullYear(),
        mDate.getMonth(),
        mDate.getDate() + 7,
        1
      )
    } else {
      newDate = new Date(
        mDate.getFullYear(),
        mDate.getMonth(),
        mDate.getDate() + 1,
        1
      )
    }
    props.onNavigate('next', newDate)
  }

  const month = () => {
    const date = moment(props.date)
    let month = date.format('MMMM')
    let year = date.format('YYYY')
    return viewState === 'month' && `${month} ${year}`
  }

  const day = () => {
    let view = viewState
    const date = moment(props.date)
    let day
    if (view === 'day') {
      day =
        date.format('ddd') +
        ' ' +
        date.format('DD') +
        ' ' +
        date.format('MMM') +
        ' ' +
        date.format('YYYY')
    }
    return <span className='rbc-toolbar-label'>{day}</span>
  }

  const week = () => {
    let view = viewState
    const date = moment(props.date)
    let startDate = moment(date).startOf('week')
    let endDate = moment(date).endOf('week')
    let day
    if (view === 'week') {
      day =
        startDate.format('MMM') +
        ' ' +
        startDate.format('Do') +
        ' - ' +
        endDate.format('MMM') +
        ' ' +
        endDate.format('Do')
    }
    return <span className='rbc-toolbar-label'>{day}</span>
  }

  const agenda = () => {
    const date = moment(props.date)
    let month = date.format('MMMM')
    let year = date.format('YYYY')
    return viewState === 'agenda' && `${month} ${year}`
  }

  const handleViewChange = (event: SelectChangeEvent) => {
    props.onView(event.target.value as string)
    setViewState(event.target.value as string)
  }

  return (
    <Box style={flexrow} sx={{ mb: 1 }} className={className.headerStyle}>
      <Box style={flexItemLeft}>
        <Typography
          align='left'
          sx={{
            fontSize: { xs: '20px', sm: '24px', md: '28px', lg: '32px' },
            fontWeight: 500
          }}
          className={className.monthWidth}
        >
          {month()}
          {week()}
          {day()}
          {agenda()}
        </Typography>

        <IconButton onClick={goToBack} size="large">
          <KeyboardArrowLeftIcon />
        </IconButton>
        <IconButton onClick={goToNext} size="large">
          <KeyboardArrowRightIcon />
        </IconButton>
      </Box>
      {!isMobView && (
        <Box style={flexItemCenter} sx={{ ml: 3 }}>
          <Select
            autoWidth={true}
            value={viewState}
            sx={{
              size: 'small',
              borderRadius: 10,
              height: 40,
              fontSize: '14px',
              fontWeight: 500,
              minWidth: 95
            }}
            MenuProps={MenuProps}
            onChange={handleViewChange}
          >
            <MenuItem value={'month'}>Month</MenuItem>
            {/* <MenuItem value={'week'}>Week</MenuItem> */}
            <MenuItem value={'day'}>Day</MenuItem>
            <MenuItem value={'agenda'}>Agenda</MenuItem>
          </Select>
        </Box>
      )}
    </Box>
  );
}
